<template>
  <div class="row d-flex justify-content-center p-0 m-0">
    <b-card class="cardDash scroll-card back-chat p-0"> 
        <div class="row m-0 mb-4 p-0 align-items-center justify-content-between header-chat"> 
          <div class="col p-0 mt-2">
            <h5 >Lista de pagamentos </h5>  
          </div>
          <div class="col-1 justify-content-end p-1"> 
            <!-- <h6 class="btn-close" @click="toDash">  </h6>   -->
          </div>  
        </div>

        <div v-if="loadingPayment" class="row my-4 align-items-center justify-content-center" >
          <b-img style="width: 180px !important;"  :src="require('../assets/loading.gif')" alt="Loading"></b-img>
        </div>

        <table v-else class="table table-striped table-bordered"> 
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Nome</th>
              <th scope="col">Tipo</th>
              <th scope="col">Data</th> 
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in listPayments" :key="index">
              <th scope="row">{{index}}</th>
              <td>{{item.name}}</td>
              <td>{{item.type}}</td>
              <td>{{dataAtualFormatada(item.creatPaymentAt)}}</td>
              <td>{{item.statusPayment == 'CONCLUIDA' ? 'Pago' : 'Pendente'}}</td> 
            </tr>
            
          </tbody>
        </table>
        <input type="text" 
          class="text-uppercase form-control mt-4" 
          v-model="txtCupom" 
          placeholder="Digite aqui o seu cupom" 
            
          aria-label="Coupon code" 
          aria-describedby="button-addon"
        >
        
        <b-button class="col btnStart mt-4 mb-4 w-100 " @click="changePayments()" variant="success" >Buscar </b-button>
        
        <div class="form-group row mt-2">
          <label for="staticEmail" class="col-12">Total pago: <b>R$ {{totalPg}},00</b></label>
        </div>
        <div class="form-group row mt-2">
          <label for="inputPassword" class="col-12">Total pendente: <b>R$ {{totalPen}},00</b></label>
        </div>

      </b-card> 
  </div>
</template>

<script>

import axios from "axios";
 
export default {
  name: 'ChatCard',
  data() {
    return {
      loadingPayment: false,
      listPayments: [],
      txtCupom: '',
      totalPg: 0,
      totalPen: 0
 
    };
  },
  mounted() {
 
  },
 
  methods: { 

    changePayments(){

      var self = this;

      this.loadingPayment = true;
      this.listPayments = [];  
  
      let token = localStorage.getItem('backoffice-token');
 
      var config = { 
        headers: { 
          'Authorization': `Bearer ${token}`
        }
      };

      this.totalPg = 0;
      this.totalPen = 0;
      
    
      axios.get( process.env.VUE_APP_APIURL+`users/couponPayment/${this.txtCupom.toUpperCase().trim()}`,config )
      .then(async (response) => {
     
        self.loadingPayment = false;  
        self.listPayments = response.data.list;  

        self.listPayments.forEach(element => {
          if(element.statusPayment == 'CONCLUIDA'){
            self.totalPg = self.totalPg + 5;
          } else {
            self.totalPen = self.totalPen + 5;
          }
        });

        console.log("🚀 ~ .then ~ response.data:", response.data)
  
      })
      .catch(async (err) => {
        self.loadingPayment = false; 
        console.log("🚀 ~ changePayments ~ err:", err) 
      });
      
    },

    dataAtualFormatada(dateTime) {
        let date = new Date(dateTime);
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();

        let hour = date.getHours();
        let min = date.getMinutes();

        let stringDate =
            (String(day).length == 1 ? "0" : "") +
            day +
            "/" +
            (String(month).length == 1 ? "0" : "") +
            month +
            "/" +
            String(year) +
            " " +
            (String(hour).length == 1 ? "0" : "") +
            hour +
            ":" +
            (String(min).length == 1 ? "0" : "") +
            min
        return stringDate;
    },
 
    toDash() { 
      this.$emit('toDash'); 
    }, 
  }
};
</script>

<style scoped>

.iframe-chat {
  height: 95%;
  width: 100%;
}
.cardDash {
  height: 90vh;
}
.scroll-card{ 
  background-size: 120%;
  max-height: 87vh;
  min-height: 80vh;
  margin-bottom: 5px;
  overflow-y: auto;
  padding: 14px 7px;
  border-radius: 5px;
}
  
</style>